function protocol() {
    return window.location.protocol;
}

function isSecured() {
    return protocol() === 'https:';
}

function hostname() {
    return window.location.hostname;
}

function port() {
    return window.location.port;
}

function pathname() {
    return window.location.pathname;
}

export default {
    protocol,
    isSecured,
    hostname,
    port,
    pathname
};
